const B = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/9371e20f-4840-4491-87e5-388382fbf526/';

export const CHECKOUT = 'https://agenda-activa.impultienda.ar/checkout';
export const PRICE = 'USD 19';
export const PRICE_OLD = 'USD 49';
export const PIXEL_ID = '4141699216132563';

export const IMG = {
  t1: B + '1793733652661_t1-portada-3518b6c8.webp',
  t2: B + '1793733711025_t2-portada-b80f9c51.webp',
  b1: B + '1793733576251_bono-1-portada-7634a6ba.webp',
  b2: B + '1793733581398_bono-2-portada-c10b916d.webp',
  b3: B + '1793733586509_bono-3-portada-97945fca.webp',
  b4: B + '1793733592130_bono-4-portada-5559ef33.webp',
};

export const PAGES: [string, string, string][] = [
  [B + '1793733608284_t1-p09-4b9de7f3.webp', 'Sesión A · Piernas firmes', 'TOMO 1'],
  [B + '1793733619541_t1-p11-94e6c794.webp', 'Ficha · Sentarse y pararse', 'TOMO 1'],
  [B + '1793733613574_t1-p10-0cfeb0dc.webp', 'Juego · La pelota que pregunta', 'TOMO 1'],
  [B + '1793733603230_t1-p07-fd793c4a.webp', 'Lámina de calentamiento', 'TOMO 1'],
  [B + '1793733662871_t2-p24-77e1a51d.webp', 'Ficha · Toque de reacción', 'TOMO 2'],
  [B + '1793733680563_t2-p63-ca8e6f78.webp', 'Ficha · Maracas caseras', 'TOMO 2'],
  [B + '1793733685841_t2-p68-1ead7422.webp', 'Ficha · Baile sentado', 'TOMO 2'],
  [B + '1793733695885_t2-p79-24b97f00.webp', 'Ficha · Abrir frascos', 'TOMO 2'],
  [B + '1793733705782_t2-p104-87b89937.webp', 'Índice por objetivo', 'TOMO 2'],
];
